export const HOEREN_TASKS = [
  {
    "id": "hoeren-teil1",
    "teil": 1,
    "title": "Teil 1 — Kurze Gespräche",
    "instruction": "Sie hören fünf Gespräche und Äußerungen. Sie hören jeden Text einmal. Zu jedem Text lösen Sie zwei Aufgaben. Wählen Sie bei jeder Aufgabe die richtige Lösung. Lesen Sie jetzt das Beispiel. Dazu haben Sie 15 Sekunden Zeit.",
    "timeMinutes": 10,
    "audioUrl": "https://goethemp4s.akamaized.net/resources/files/mp477/b2_modellsatz_rahmen_erwachsene-v72.mp4",
    "audioSegments": [
      {
        "id": "seg1",
        "label": "Aufgabe 1–2",
        "script": "F: Warum liest du Romane?\nM: Dabei kann ich mich gut entspannen. Wenn ich lese, vergesse ich die Welt um mich herum. Ich befinde mich in einer märchenhaften Welt, kann mit den Romanhelden fühlen und die Geschichte miterleben. Danach fühle ich mich wie andere nach einem Bad oder nach der Sauna. Filme mag ich nicht so sehr. Das ist mir alles viel zu real. Da jagt eine Szene die nächste. Man kommt gar nicht zum Nachdenken."
      },
      {
        "id": "seg2",
        "label": "Aufgabe 3–4",
        "script": "M: Unser nächstes Thema in der Wirtschaftswoche: In vielen Ländern gibt es schon keine 1-Cent-Münzen mehr. Und auch die anderen Münzen und Geldscheine werden immer seltener benutzt. Die Leute zahlen lieber mit ihrer Bank- oder Kreditkarte.\nF: Ja, richtig. Vor allem wenn sie im Internet einkaufen oder auf Reisen sind. Das ist sehr nützlich, weil man dann zum Beispiel sein Geld nicht mehr umtauschen muss. Außerdem gibt es in manchen Ländern Geschäfte, in denen man mit Karte zahlen muss. Die nehmen gar kein Bargeld mehr an. Bald wird überall nur noch mit Karte bezahlt. Da bin ich mir sicher."
      },
      {
        "id": "seg3",
        "label": "Aufgabe 5–6",
        "script": "F: Wie war denn dein Praktikum eigentlich?\nM: Mein Praktikum? Das war echt toll! Ich war ja in der Anwaltskanzlei und hab einen echt guten Einblick in ihre Arbeit bekommen. Ich konnte sogar zu ein paar Terminen bei Gericht mitgehen. Das war sehr spannend. Aber auch die anderen Aufgaben haben mir gefallen. Natürlich musste ich auch mal Kaffee kochen oder Kopien machen, aber das war nicht schlimm. Ich konnte mich sogar in Fälle einlesen, die für mein Seminar in Verfassungsrecht echt hilfreich sind."
      },
      {
        "id": "seg4",
        "label": "Aufgabe 7–8",
        "script": "M: Es gibt immer mehr Unfälle mit Radfahrern. Experten wollen deswegen, dass Fahrradfahren sicherer wird. Eine Idee ist, dass jedes Fahrrad wie ein Auto ein Nummernschild haben muss. Das Problem: Radfahrer sind schuld an einem Unfall, wenn sie einfach bei Rot über die Ampel fahren und zwei Autos deswegen zusammenstoßen. Wenn der Radfahrer einfach wegfährt, weiß die Polizei nicht, wer das war. Mit einem Nummernschild wie beim Auto könnten die Polizisten das aber herausfinden. Schließlich fanden die Experten den Vorschlag aber doch zu unpraktisch."
      },
      {
        "id": "seg5",
        "label": "Aufgabe 9–10",
        "script": "F: Ich find das Seminar bei Professor Köster echt gut.\nM: Ja. Ich auch.\nF: Hast du schon ein Thema für das Referat?\nM: Nein, habe ich noch nicht. Ich hab auch, ehrlich gesagt, gar keine Idee. Hast du denn schon eine?\nF: Nein, auch noch nicht. Aber ich habe mir schon ein paar Gedanken gemacht und werde nächste Woche in seine Sprechstunde gehen.\nM: Worüber würdest du denn gerne sprechen?\nF: Ich würde gerne darüber referieren, wie Afrika in der neueren deutschen Literatur dargestellt wird. Also wie zum Beispiel afrikanische Figuren in Romanen dargestellt werden.\nM: Toll!"
      }
    ],
    "audioScript": "[Aufgabe 1–2] F: Warum liest du Romane? M: Dabei kann ich mich gut entspannen...\n\n[Aufgabe 3–4] M: Unser nächstes Thema in der Wirtschaftswoche...\n\n[Aufgabe 5–6] F: Wie war denn dein Praktikum eigentlich?...\n\n[Aufgabe 7–8] M: Es gibt immer mehr Unfälle mit Radfahrern...\n\n[Aufgabe 9–10] F: Ich find das Seminar bei Professor Köster echt gut...",
    "questions": [
      {
        "id": "h1",
        "segment": "seg1",
        "type": "truefalse",
        "question": "Die Frau spricht darüber, warum sie sich für Literatur interessiert.",
        "correct": true
      },
      {
        "id": "h2",
        "segment": "seg1",
        "question": "Welche Meinung hat die Frau über das Lesen?",
        "options": [
          "Zum Romanlesen braucht sie ihre Fantasie.",
          "Sie hat oft zu wenig Zeit, sich eigene Gedanken zu machen.",
          "Was sie gelesen hat, bleibt nicht lang im Gedächtnis."
        ],
        "correct": 0
      },
      {
        "id": "h3",
        "segment": "seg2",
        "type": "truefalse",
        "question": "Die Frau berichtet über die Zahlungsmoral in vielen Ländern.",
        "correct": false
      },
      {
        "id": "h4",
        "segment": "seg2",
        "question": "Was wird immer seltener gemacht?",
        "options": [
          "Im Internet eingekauft.",
          "Geld gewechselt.",
          "Mit Bargeld bezahlt."
        ],
        "correct": 2
      },
      {
        "id": "h5",
        "segment": "seg3",
        "type": "truefalse",
        "question": "Die Frau hat ein Praktikum bei einem Gericht gemacht.",
        "correct": false
      },
      {
        "id": "h6",
        "segment": "seg3",
        "question": "Die Frau fand ihre Aufgaben …",
        "options": [
          "wie zum Beispiel Kaffee kochen unangenehm.",
          "nützlich für ihr Studium.",
          "für ihre berufliche Tätigkeit sehr hilfreich."
        ],
        "correct": 1
      },
      {
        "id": "h7",
        "segment": "seg4",
        "type": "truefalse",
        "question": "Der Mann berichtet über Sicherheit im Straßenverkehr.",
        "correct": true
      },
      {
        "id": "h8",
        "segment": "seg4",
        "question": "Nummernschilder bei Fahrrädern …",
        "options": [
          "lehnen Experten ab.",
          "halten Experten für eine gute Idee.",
          "möchten Experten ausprobieren."
        ],
        "correct": 0
      },
      {
        "id": "h9",
        "segment": "seg5",
        "type": "truefalse",
        "question": "Die beiden Freunde unterhalten sich über einen Professor.",
        "correct": true
      },
      {
        "id": "h10",
        "segment": "seg5",
        "question": "Die beiden Freunde brauchen noch ein Thema für …",
        "options": [
          "eine Präsentation.",
          "einen Aufsatz.",
          "eine Seminararbeit."
        ],
        "correct": 2
      }
    ]
  },
  {
    "id": "hoeren-teil2",
    "teil": 2,
    "title": "Teil 2 — Interview Frau Neuhaus",
    "instruction": "Sie hören im Radio ein Interview mit einer Persönlichkeit aus der Wissenschaft. Sie hören den Text zweimal. Wählen Sie bei jeder Aufgabe die richtige Lösung. Lesen Sie jetzt die Aufgaben 11 bis 16. Dazu haben Sie 90 Sekunden Zeit.",
    "timeMinutes": 10,
    "audioUrl": "https://goethemp4s.akamaized.net/resources/files/mp477/b2_modellsatz_rahmen_erwachsene-v72.mp4",
    "audioScript": "Moderator: Ich begrüße heute Doktor Helene Neuhaus, Leiterin des Instituts für 'gesunde Ernährung und nachhaltige Lebensmittelproduktion'. Sie sagt: Wir müssen unsere Ernährungsgewohnheiten und unsere Lebensmittelproduktion in Zukunft radikal umstellen. Fangen wir mal mit der Ernährung an, Frau Neuhaus: Was muss sich da vor allem ändern?\n\nFrau Neuhaus: Auf jeden Fall ist es gut, wenn wir uns über die Folgen unserer Ernährung bewusst werden. Was bedeutet es für die Umwelt, wenn ich mich für ein bestimmtes Essen entscheide? Was hat das für Konsequenzen, wenn ich Fisch oder Rindfleisch wähle, oder wenn ich mich stattdessen vegetarisch ernähre, das heißt vielleicht Sojabohnen oder Erbsen esse, um Proteine zu mir zu nehmen?\n\nModerator: Bleiben wir vielleicht mal beim Fleisch, weil ja viele sagen, das können wir uns auf Dauer gar nicht leisten, so viel Fleischkonsum.\n\nFrau Neuhaus: Wie ernähren wir die wachsende Weltbevölkerung, ist ja die Frage, die dahinter steht. Wir beobachten heute: Es gibt in vielen Ländern immer mehr Menschen, die sich Fleisch leisten können. So entsteht eine wachsende Nachfrage nach Fleisch. Man kann dort aber nicht einfach die Fleischproduktion entsprechend erhöhen.\n\nModerator: Aber womit lässt sich Fleisch denn ersetzen?\n\nFrau Neuhaus: Eine mögliche Alternative sind Insekten, also z. B. Käfer oder Ähnliches; frittiert schmecken sie ähnlich wie die Haut von Brathähnchen. Man kann Insekten auch karamellisieren oder in Schokolade tauchen. Sie lassen sich auch gut für verarbeitete Produkte nutzen, zum Beispiel Insektenriegel statt Schokoriegel. Die Zubereitung kennt keine Grenzen.\n\nModerator: Warum ist in Asien der Insekten-Konsum in den letzten Jahren so stark gestiegen?\n\nFrau Neuhaus: Dort war das Essen von Insekten schon immer eine Selbstverständlichkeit. Früher hat man Käfer, Raupen und viele andere Insekten im Wald und auf Feldern mühsam gesammelt, heutzutage dagegen werden sie in landwirtschaftlichen Betrieben gezüchtet.\n\nModerator: Ein zweites großes Thema ist ja für Sie das Umdenken bei der 'Landwirtschaft'. Ein aktueller Trend in westlichen Metropolen ist es, Gemüse im Hochhaus oder in Gärten in der Stadt anzubauen. Was sagen Sie dazu?\n\nFrau Neuhaus: Also, ich halte das für sehr zukunftsweisend, denn da spart man vor allem Wasser, da spart man Dünger. Es rentiert sich auf jeden Fall für den Anbau von Salat und Kräutern. Allerdings ist der Anbau sehr stromintensiv, und für die Produktion anderer Nutzpflanzen wie Weizen und Kartoffeln werden immer noch große Flächen gebraucht.\n\nModerator: Sie forschen ja auch zum Thema 'individualisierte Landwirtschaft'. Was ist das genau?\n\nFrau Neuhaus: Es geht darum, mehr Rücksicht auf die Lebensqualität der Tiere zu nehmen; dass zum Beispiel in der Milchproduktion ein Computer erkennt, ob und wie viel Milch die Kuh gerade hat. Eigentlich ist es nur eine intelligente Melkmaschine, die da eingesetzt wird.",
    "questions": [
      {
        "id": "h11",
        "question": "Frau Neuhaus findet es für unsere zukünftige Ernährung wichtig, …",
        "options": [
          "an die Konsequenzen unserer Entscheidung zu denken.",
          "uns mit Fleisch und Fisch zu ernähren.",
          "mehr Erbsen und Sojabohnen zu essen."
        ],
        "correct": 0
      },
      {
        "id": "h12",
        "question": "Was ist die Ursache für wachsenden Fleischkonsum?",
        "options": [
          "Die Fleischproduktion ist gestiegen.",
          "Die Weltbevölkerung ist gewachsen.",
          "Mehr Menschen haben genug Geld für Fleisch."
        ],
        "correct": 2
      },
      {
        "id": "h13",
        "question": "Warum sehen viele in Insekten eine Alternative zu Fleisch?",
        "options": [
          "Sie lassen sich gut zu Schokolade verarbeiten.",
          "Es gibt viele Zubereitungsarten.",
          "Sie schmecken wie Hähnchenfleisch."
        ],
        "correct": 2
      },
      {
        "id": "h14",
        "question": "Warum isst man in Asien heute Insekten? Dort …",
        "options": [
          "gibt es viele verschiedene Insekten.",
          "ist das Insekten-Essen selbstverständlich.",
          "werden Insekten industriell produziert."
        ],
        "correct": 1
      },
      {
        "id": "h15",
        "question": "Was ist der Vorteil einer Landwirtschaft in städtischen Gebieten?",
        "options": [
          "Der Wasserverbrauch sinkt.",
          "Man spart Strom.",
          "Sie ist für alle Nutzpflanzen geeignet."
        ],
        "correct": 0
      },
      {
        "id": "h16",
        "question": "Was bedeutet 'individualisierte Landwirtschaft'?",
        "options": [
          "Die Produktion passt sich an das einzelne Tier an.",
          "Computer zeigen an, wie viel Milch eine Kuh gegeben hat.",
          "Die Qualität der Milchprodukte steigt."
        ],
        "correct": 0
      }
    ]
  },
  {
    "id": "hoeren-teil3",
    "teil": 3,
    "title": "Teil 3 — Alternative Wohnformen",
    "instruction": "Sie hören im Radio ein Gespräch mit mehreren Personen. Die Personen sprechen über alternative Wohnformen. Sie hören den Text einmal. Wählen Sie bei jeder Aufgabe: Wer sagt das? Lesen Sie jetzt die Aufgaben 17 bis 22. Dazu haben Sie 60 Sekunden Zeit.",
    "timeMinutes": 10,
    "audioUrl": "https://goethemp4s.akamaized.net/resources/files/mp477/b2_modellsatz_rahmen_erwachsene-v72.mp4",
    "speakers": [
      {
        "id": "a",
        "label": "a",
        "name": "Moderator"
      },
      {
        "id": "b",
        "label": "b",
        "name": "Frau Gerster, Studentin"
      },
      {
        "id": "c",
        "label": "c",
        "name": "Frau Lücke, Seniorin"
      }
    ],
    "audioScript": "Moderator: Schön, dass Sie mit dabei sind, hier bei Radio LOLA. Heute geht es um die Frage: Wohnungsnot und steigende Mietpreise. Welche Alternativen gibt es eigentlich in Städten wie Berlin, München und Hamburg? Sind Wohngemeinschaften ein Ausweg aus der Wohnungsnot? Mein erster Gast im Studio ist Lisa Gerster...\n\nLisa Gerster: Als ich zum Studium nach Berlin kam, hatte ich nicht viel Geld und zog in eine WG...\n\nFrau Lücke: Ich wohne zusammen mit neun anderen Personen, jeder hat seine eigene kleine Wohnung...\n\n[Vollständiger Dialog im Transkript]",
    "questions": [
      {
        "id": "h17",
        "type": "speaker_match",
        "question": "Er/Sie lebt aus finanziellen Gründen mit anderen zusammen.",
        "correct": "b"
      },
      {
        "id": "h18",
        "type": "speaker_match",
        "question": "Eine WG-Wohnung sollte auch Raum zum Alleinsein bieten.",
        "correct": "b"
      },
      {
        "id": "h19",
        "type": "speaker_match",
        "question": "Es ist schön, Gesprächspartner in der Nähe zu haben.",
        "correct": "b"
      },
      {
        "id": "h20",
        "type": "speaker_match",
        "question": "Wohngemeinschaften für Menschen verschiedenen Alters sind neu.",
        "correct": "a"
      },
      {
        "id": "h21",
        "type": "speaker_match",
        "question": "Wohngemeinschaften können für die Bewohner nützlich sein.",
        "correct": "c"
      },
      {
        "id": "h22",
        "type": "speaker_match",
        "question": "Wohngemeinschaften sind für Senioren passender als für Studenten.",
        "correct": "c"
      }
    ]
  },
  {
    "id": "hoeren-teil4",
    "teil": 4,
    "title": "Teil 4 — Bessere Arbeitstechniken",
    "instruction": "Sie hören einen kurzen Vortrag. Der Redner spricht über bessere Arbeitstechniken. Sie hören den Text zweimal. Wählen Sie bei jeder Aufgabe die richtige Lösung. Lesen Sie jetzt die Aufgaben 23 bis 30. Dazu haben Sie 90 Sekunden Zeit.",
    "timeMinutes": 10,
    "audioUrl": "https://goethemp4s.akamaized.net/resources/files/mp477/b2_modellsatz_rahmen_erwachsene-v72.mp4",
    "audioScript": "Herzlich willkommen, meine sehr verehrten Damen und Herren, zu meinem Vortrag 'Ordnung im Kopf'. Ich bin Jochen Kinigard von der Universität Bonn.\n\nWer kennt das nicht? Man versucht, zu arbeiten, doch ständig wandern die Augen zu den ungelesenen E-Mails auf dem Bildschirm, zum blinkenden oder klingelnden Handy oder den noch zu erledigenden Aufgaben. Bis zu 23 Minuten kann es nach solchen Störungen dauern, bis wir wieder fokussiert arbeiten und im 'Flow' sind, wie wir das nennen.\n\nSeien wir doch mal ehrlich: Zerstreuung ist ein Merkmal unserer Zeit. Den gesamten Tag füttern wir unser Hirn mit leeren Kalorien, das heißt mit Dingen, die nicht zu der eigentlichen Aufgabe gehören.\n\nEs scheint unmöglich, voll konzentriert zu arbeiten. Es andauernd zu versuchen kostet Kraft und ist wenig zielführend. Aber das wirklich konzentrierte Arbeiten ohne Ablenkungen schafft das größte Hochgefühl.\n\nMehrere Dinge gleichzeitig zu tun hilft dagegen nichts: Es werden zwar mehrere Dinge parallel erledigt, jedoch leidet das Ergebnis stark darunter.\n\nWas aber bekanntlich hilft, ist Dinge ins externe Gedächtnis zu verschieben. Das tut man, indem man zum Beispiel Adressen aufschreibt oder Einkaufslisten.\n\nRuhepausen sind per Gesetz vorgeschrieben, vom Arbeitgeber oft stark reguliert. Fluglotsen beispielsweise machen alle 2 Stunden 30 Minuten Pause – das empfinde ich als Wissenschaftler als richtig.\n\nBeim Arbeiten unter Zeitdruck kommen ebenfalls oft die besten und kreativsten Ideen. Vorherige Denkblockaden lösen sich oft auf und der zeitliche Druck wird nicht als stressig, sondern als motivierend empfunden.\n\nZusammenfassend: Es ist wichtig, Ablenkungen als solche zu erkennen und – wenn möglich – gar nicht erst entstehen zu lassen. Meiner Meinung nach reicht es beispielsweise, die E-Mails alle zwei bis drei Stunden anzusehen und dazwischen voll konzentriert zu arbeiten.",
    "questions": [
      {
        "id": "h23",
        "question": "Es dauert mehr als 20 Minuten, …",
        "options": [
          "nach einer Störung umzuschalten.",
          "eine Aufgabe zu erledigen.",
          "sich in eine neue Aufgabe einzuarbeiten."
        ],
        "correct": 0
      },
      {
        "id": "h24",
        "question": "Was meint Herr Kinigard mit 'leeren Kalorien'?",
        "options": [
          "Inhaltslose Dinge.",
          "Informationen, die nicht relevant sind.",
          "Dinge, die sehr komplex sind."
        ],
        "correct": 0
      },
      {
        "id": "h25",
        "question": "Der Versuch, konzentriert zu arbeiten, …",
        "options": [
          "ist erfolgversprechend.",
          "macht glücklich.",
          "strengt an."
        ],
        "correct": 2
      },
      {
        "id": "h26",
        "question": "Mehrere Dinge gleichzeitig zu tun, …",
        "options": [
          "ändert nichts am Ergebnis.",
          "verbessert das Ergebnis.",
          "verschlechtert das Ergebnis."
        ],
        "correct": 2
      },
      {
        "id": "h27",
        "question": "Ein externes Gedächtnis wird geschaffen, indem man …",
        "options": [
          "Dinge aufschreibt.",
          "sich auf andere Dinge konzentriert.",
          "den Kopf frei macht."
        ],
        "correct": 0
      },
      {
        "id": "h28",
        "question": "Laut Herrn Kinigard sind gesetzliche Ruhepausen …",
        "options": [
          "unnötig.",
          "wichtig.",
          "zu stark reguliert."
        ],
        "correct": 1
      },
      {
        "id": "h29",
        "question": "Wozu kann Zeitdruck führen?",
        "options": [
          "Zu hervorragenden Ergebnissen.",
          "Zu langen Blockaden.",
          "Zu negativem Stress."
        ],
        "correct": 0
      },
      {
        "id": "h30",
        "question": "Herr Kinigard rät dazu, …",
        "options": [
          "Ablenkungen zu vermeiden.",
          "auf Einflüsse von außen nicht zu reagieren.",
          "E-Mail-Korrespondenz zu reduzieren."
        ],
        "correct": 0
      }
    ]
  }
];
